import React, { Component } from "react";
import LegislationTable from "../../components/LegislationTable/LegislationTable";
import Modal from "../../hoc/UI/Modal/Modal";
import Aux from "../../hoc/Auxilary";
import LegislationModal from "../../components/LegislationModal/LegislationModal";
import axiosInstance from "../../axios-project";
import AllStates from "../../components/AllStates";

class LegislationOverview extends Component {
  state = {
    legislationDetails: [],
    baseURL: "https://api.transportationprojects.org/api",
    showModal: false,
    showEditModal: false,
    currentLegislationID: null,
    currentLegislation: {},
    newProjectMode: true,
    page: 0
  };

  changePage = p => {
    this.setState({
      page: p
    });
  };

  fetchLegislationDetails = () => {
    axiosInstance
      .get("/legislative")
      .then(response => {
        this.setState(prevState => {
          return {
            legislationDetails: response.data
          };
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  componentDidMount() {
    this.fetchLegislationDetails();
    window.onpopstate = e => {
      this.closeModalHandler();
    };
  }

  closeModalHandler = () => {
    this.setState({
      showModal: false
    });
    this.fetchLegislationDetails();
  };

  toggleModalHandler = legislationID => {
    this.setState(prevState => {
      return {
        showModal: true,
        currentLegislationID: legislationID
      };
    });
  };

  submit = legislation => {
    legislation.state_id = AllStates.find(
      s =>
        s.state_name === legislation.state_id ||
        s.state_id === legislation.state_id
    ).state_id;
    axiosInstance
      .post(`/legislative`, legislation)
      .then(response => {
        this.closeModalHandler();
      })
      .catch(error => {
        this.fetchLegislationDetails();
        console.log(error);
      });
  };

  createNewLegislation = () => {
    this.setState({
      showModal: true,
      currentLegislationID: null
    });
  };

  render() {
    let modal;

    const isAdmin =
        localStorage.getItem("role") &&
        JSON.parse(localStorage.getItem("role")).some(
            r => r.name === "ROLE_ADMIN"
        );

    if (this.state.showModal) {
      modal = (
        <Modal>
          <LegislationModal
            closeModalHandler={this.closeModalHandler}
            legislationItems={this.state.legislationDetails}
            submit={this.submit}
            legislationID={this.state.currentLegislationID}
          />
        </Modal>
      );
    }
    return (
      <div>
        <Aux>
          {modal}
          {!this.state.showModal ? (
            <div>
              {isAdmin ? ( <div className="text-right">
                <button
                  className={"btn btn-outline-primary btn-sm my-2"}
                  type="button"
                  onClick={this.createNewLegislation}
                >
                  Create new Legislation
                </button>
              </div> ) : null }
              <LegislationTable
                clicked={this.toggleModalHandler}
                legislationItems={this.state.legislationDetails}
                page={this.state.page}
                changePage={this.changePage}
              />
            </div>
          ) : (
            ""
          )}
        </Aux>
      </div>
    );
  }
}

export default LegislationOverview;
